
export default function SpitiWeather() {
    return (
        <div >
            <a class="weatherwidget-io" href="https://forecast7.com/en/32d2378d07/kaza/" data-label_1="SPITI" data-label_2="WEATHER" data-font="Play" data-icons="Climacons Animated" data-days="7" data-theme="blue-mountains" >SPITI WEATHER</a>
        </div>
    )
}